import { useControllableValue } from 'ahooks';
import { InputNumber, InputNumberProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import SwapRight from '@/assets/images/icons/SwapRight.react.svg?react';
import { BaseFormItemProps, PropsWithStyles } from '@/presentation/components/tds-form/type';
import './index.module.scss';

export interface TdsInputNumberRangeProps<T = any> extends BaseFormItemProps<T> {
  minInputProps?: InputNumberProps;
  maxInputProps?: InputNumberProps;
};

export type TdsInputNumberRange = {
  min?: number | null;
  max?: number | null;
};

export const TdsInputNumberRange = (props: PropsWithStyles<TdsInputNumberRangeProps>) => {
  const [value, setValue] = useControllableValue<TdsInputNumberRange>(props, {
    defaultValue: {
      min: undefined,
      max: undefined,
    },
  });

  const onMinValueChange = (minValue: number | null) => {
    setValue({
      ...value,
      min: minValue,
    });
  };

  const onMaxValueChange = (maxValue: number | null) => {
    setValue({
      ...value,
      max: maxValue,
    });
  };

  return (
    <div className={classNames('tds-number-range', props.className)} style={props.style}>
      <InputNumber
        controls={false}
        value={value?.min}
        onChange={onMinValueChange}
      />
      <SwapRight/>
      <InputNumber
        controls={false}
        value={value?.max}
        onChange={onMaxValueChange}
      />
    </div>
  );
};
